import { Component, OnInit, AfterViewChecked, ViewChild } from '@angular/core';
import { UserService, User } from "app/services/user.service";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseComponent } from "app/components/base.component";
import { CompanyService, Company } from "app/services/company.service";
import { NgForm } from "@angular/forms";
import { NotificationsService } from "angular2-notifications";
import { FirebaseService } from "app/services/firebase.service";

@Component({
	selector: 'app-user-add-edit',
	templateUrl: './user-add-edit.component.html',
	styleUrls: ['./user-add-edit.component.css']
})
export class UserAddEditComponent extends BaseComponent implements OnInit {
	item: User;
	companies: Company[];
	companies_multi = [];
	companies_multi_active = [];
	param_id: string;
	loading;
	fb_error;

	userForm: NgForm;
	@ViewChild('userForm') currentForm: NgForm;

	formTitle = 'Add New User';
	buttonText = 'Save User';

	constructor(
		private userService: UserService,
		private firebaseService: FirebaseService,
		private companyService: CompanyService,
		private router: Router,
		private route: ActivatedRoute,
		private notificationsService: NotificationsService,
	) {
		super();
	}

	ngOnInit() {
		var self = this;
		this.item = new User();
		this.param_id = this.route.snapshot.params['id'];
		if (this.param_id) {
			this.userService.getUser(this.param_id).subscribe(user => {
				this.item = Object.assign(new User(), user);
				this.formTitle = 'Edit User';
				this.buttonText = 'Update User';
			});
		}

		this.companyService.getCompanies().subscribe(companies => {
			this.companies = companies;
			this.companies_multi = [];
			this.companies_multi_active = [];
			companies.forEach((item, i) => {
				this.companies_multi.push({
					id: item.$key,
					text: item.name
				})

				if (self.item.companies.indexOf(item.$key) > -1) {
					this.companies_multi_active.push({
						id: item.$key,
						text: item.name
					})
				}
			})
		})
	}

	companies_refreshValue(value: any) {
		var companies = value.map(item => item.id);
		// console.log(companies);
		this.item.companies = companies;
	}

	formAction() {
		if(this.formValidation(false)){
			if (this.param_id) {
				this.loading = 'true';
				this.userService.updateUser(this.param_id, this.item).then(() => {
					this.router.navigate(['/user']);
					this.loading = '';
					this.notificationsService.success('Updated', 'User updated')
				})
			}
			else {
				this.loading = 'true';
				this.userService.create_firebaase_user(this.item).then(user => {
					this.router.navigate(['/user']);
					this.loading = '';
					this.notificationsService.success('Added', '1 user added')
				}).catch(reason => {
					console.log(reason);
					this.fb_error = reason;
					this.loading = '';
					if (this.fb_error == 'The email address is already in use by another account.'){
						this.formErrors.email = this.fb_error;
					}
					if (this.fb_error == 'Password should be at least 6 characters') {
						this.formErrors.password = this.fb_error;
					}
				})
			}
		}
	}

	onResetPasswd(email){
		var self = this;
		if(confirm('Are you sure? An email will be sent to this user email address for reset password. Please inform the user to check the email.')){
			this.firebaseService.resetPassword(email).then(function(){
				self.notificationsService.success('Sent', 'Reset password request sent to email.');
			}).catch(e => {
				console.log(e);
			})
		}

	}

	ngAfterViewChecked() {
		this.formChanged();
	}

	formChanged() {
		if (this.currentForm === this.userForm) { return; }

		this.userForm = this.currentForm;
		if (this.userForm) {
			this.userForm.valueChanges
				.subscribe(data => {
					this.formValidation(true);
					this.fb_error = '';

					if(this.item.level != 'sales') {
						this.item.companies = [];
					}
				});
		}
	}

	formValidation(checkDirty = true) {
		const form = this.userForm.form;
		for (const field in form.controls) {
			const control = form.get(field)
			if (control) {
				if (checkDirty && !control.dirty) {
					continue;
				}
				this.formErrors[field] = '';
				if (!control.valid) {
					const messages = this.validationMessages[field] || {};
					for (const key in control.errors) {
						this.formErrors[field] += messages[key] + ' ';
					}
				}
			}
		}

		return form.valid;
	}

	formErrors = {
		'fullname': '',
		'email': '',
		'password': '',
		'employee_number': '',
		'phone': '',
		'position': '',
	};

	validationMessages = {
		'fullname': {
			'required':'This field is required.',
		},
		'email': {
			'required':'This field is required.',
			'pattern' : 'Please provide a valid email address'
		},
		'password': {
			'required':'This field is required.',
		},
		'employee_number': {
			'required':'This field is required.',
		},
		'phone': {
			'required':'This field is required.',
			'pattern' : 'Please provid a valid phone number'
		},
		'position': {
			'required':'This field is required.',
		},
	};

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/user/user-add-edit/user-add-edit.component.ts